export default "__VITE_ASSET__CW032Vah__"